import { InputAdornment, TextField, TextFieldProps, Typography } from '@mui/material'

type CharacterCountedTextFieldProps = Omit<TextFieldProps, 'InputProps' | 'inputProps'> & {
  value: string
  maxLength: number
}

const textFieldStyles = {
  '& .MuiOutlinedInput-root': {
    fontSize: 12,
    color: 'text.primary',
  },
}

/**
 * Reusable TextField with character counter
 */
export function CharacterCountedTextField(props: CharacterCountedTextFieldProps) {
  const { value, maxLength, sx, ...restProps } = props
  const multilineProps = restProps.multiline ? { minRows: restProps.minRows ?? 2 } : {}

  return (
    <TextField
      {...restProps}
      {...multilineProps}
      value={value}
      inputProps={{ maxLength }}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <Typography variant="caption" sx={{ color: 'text.secondary' }}>
              {value.length}/{maxLength}
            </Typography>
          </InputAdornment>
        ),
      }}
      sx={{ width: '100%', ...textFieldStyles, ...sx }}
    />
  )
}
